<script>
import moment from 'moment-timezone';
import browser from 'browser-detect';
import Auth from './Auth.vue';

export default {
  name: 'global-students',
  mixins: [Auth],
  methods: {
    async $students(request) {
      const call = await this._invokeFn({
        payload: { request },
      });
      const response = this._apiResponse(call.Payload);
      this._checkApiErrors(response, call);
      return response;
    },
    async _invokeFn({ payload }) {
      const {
        VUE_APP_LAMBDA_REGION,
        VUE_APP_LAMBDA_PROXY,
        VUE_APP_LAMBDA_VERSION,
      } = process.env;
      const STUDENTS = `${VUE_APP_LAMBDA_PROXY}:${VUE_APP_LAMBDA_VERSION}`;
      // check for expired sessions first
      const user = await this.$checkSession();
      payload.sub = user.username;
      payload.request.time = {
        stamp: new Date().toISOString(),
        zone: moment.tz.guess(),
      };
      payload.request.browser = browser();
      const params = {
        FunctionName: STUDENTS,
        InvocationType: 'RequestResponse',
        Payload: JSON.stringify(payload),
        LogType: 'None',
      };
      const lambda = new this.$aws.Lambda({ region: VUE_APP_LAMBDA_REGION });
      return lambda.invoke(params).promise();
    },
    _checkApiErrors(p, call) {
      if (!p && call && call.FunctionError === 'Unhandled' && call.Payload) {
        const unhandled = this._apiResponse(call.Payload);
        throw new Error(unhandled.errorMessage);
      }
      const error = p !== null && p.errorMessage;
      if (error) {
        throw new Error(error);
      }
    },
    _apiResponse(p) {
      return typeof p === 'string' ? JSON.parse(p) : p;
    },
  },
};
</script>
